import PubSub from "pubsub-js";

var HeroHomepage = function (options) {

  this.options = {
    $el: false,
    baseClass: 'comp-HeroHomepage',
  };

  $.extend(true, this.options, options);

};

HeroHomepage.prototype.init = function () {

  var self = this;

  self.$hamburger = self.options.$el.find(`.${self.options.baseClass}__hamburger`);

  self.$hamburger.on('click', () => {
    self.$hamburger.find(`.el-NavBar__hamburger`).trigger('click');
  })

};

export default HeroHomepage;